import { Months } from '../Months';
const {
  JANUARY,
  DECEMBER
} = Months;
function getPrevMonth(_ref) {
  let [month, year] = _ref;
  if (month === JANUARY + 1) {
    return [DECEMBER + 1, year - 1];
  }
  return [month - 1, year];
}
export default getPrevMonth;
//# sourceMappingURL=getPrevMonth.js.map